import React, { Component } from "react";
import axios from "axios";
import { BounceLoader } from "react-spinners";

// components
import Sidebar from "./components/Sidebar/Sidebar";
import ActiveStep from "./components/ActiveStep/ActiveStep";
import Button from "./components/Button/Button";
import Finish from "./components/Finish/Finish";
import Overlay from "./components/Overlay/Overlay";

// utilities
import validate from "./util/validation";

// settings
import FormSettings from "./assets/form.json";
import FormSettingsEn from "./assets/form.en.json";

// assets
import Strings from "./assets/strings.json";

class App extends Component {
  state = {
    form:
      document.body.dataset.lang === "default" ? FormSettings : FormSettingsEn,
    finish: {},
    completed: false,
    step: 0,
    departments: null,
    copy: null,
    loading: true,
    currentDep: null,
    sendMe: true,
    error: "",
    lang: document.body.dataset.lang,
    tablet: false,
    moreThanTablet: false,
    phone: false,
    moreThanPhone: false,
    showOverlay: false,
    overlayContent: "",
  };

  componentDidMount = () => {
    axios
      .get(
        (process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_NOT_SECRET_CODE
          : "") + "/api/departments.json",
        {
          headers: {
            "X-Api-Key": process.env.REACT_APP_API_KEY,
          },
        }
      )
      .then((res) => {
        this.setState({ departments: res.data.data });
      });

    axios
      .get(
        (process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_NOT_SECRET_CODE
          : "") +
          "/api/form.json?lang=" +
          this.state.lang
      )
      .then((res) => {
        const copy = res.data;
        this.setState((prevState) => {
          prevState.form.forEach((el, i) => {
            prevState.form[i].name = copy.copy[i].short;
            prevState.form[i].title = copy.copy[i].title;
            prevState.form[i].desc = copy.copy[i].body;
          });

          prevState.form[1].fields[0].options = copy.cats;

          prevState.loading = false;
          prevState.finish = copy.copy[copy.copy.length - 1];
          return prevState;
        });
      });
    this.screenSizes();
    window.addEventListener("resize", this.screenSizes);
  };

  screenSizes = () => {
    this.setState({
      tablet: window.matchMedia("(max-width: 768px)").matches,
      moreThanTablet: window.matchMedia("(min-width: 769px)").matches,
      phone: window.matchMedia("(max-width: 576px)").matches,
      moreThanPhone: window.matchMedia("(min-width: 577px)").matches,
    });
  };

  changeStep = (i) => {
    if (this.state.tablet) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    } else {
      document.querySelector(".main-inner").scrollTop = 0;
    }

    this.setState((prevState) => ({
      form: prevState.form.map((step, ii) => ({
        ...step,
        active: ii === i,
      })),
      step: i,
    }));
  };

  submitHandler = (e) => {
    e.preventDefault();
    if (this.state.tablet) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    } else {
      document.querySelector(".main-inner").scrollTop = 0;
    }

    const form = this.prepareData(this.state.form);
    this.setState({ loading: true });

    axios
      .get(
        (process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_NOT_SECRET_CODE
          : "") + "/dynamic/csrf"
      )
      .then(({ data }) => {
        const name = data.name;
        const value = data.value;

        axios({
          method: "post",
          url:
            (process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_NOT_SECRET_CODE
              : "") +
            (this.state.lang === "branntipsEn" ? "/en" : "") +
            "/actions/common-module/default/index",
          data: {
            [name]: value,
            form,
          },
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          responseType: "json",
        })
          .then((res) => {
            if (res.data.error) {
              this.setState({
                loading: false,
                error: res.data.error,
              });
            } else {
              this.setState((prevState) => ({
                completed: true,
                loading: false,
                currentDep: res.data,
                step: prevState.step + 1,
                form: prevState.form.map((step) => ({
                  ...step,
                  active: false,
                  completed: true,
                })),
              }));
            }
          })
          .catch((err) => {
            this.setState({
              loading: false,
              error: Strings[this.state.lang].error,
            });
          });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: Strings[this.state.lang].error,
        });
      });
  };

  prepareData = (data) => {
    const result = [];
    data.forEach((group) => {
      const values = [];
      group.fields.forEach((f) => {
        if (f.name !== "notEmergency") {
          values.push({
            id: f.name,
            name: f.title || f.name,
            value: f.value,
            required: f.validate && f.validate.required,
          });
        }
      });

      result.push({
        name: group.title,
        values,
      });
    });

    return result;
  };

  changeHandler = (el, value, settings = {}) => {
    settings.departments = this.state.departments;

    // this if statement should be shown only for Oslo and Sarpsborg and only until 1st of July 2023
    // get the date object with Norway timezone
    const endDate = new Date(
      new Date("2023-07-01").toLocaleString("en-US", {
        timeZone: "Europe/Oslo",
      })
    );

    const exceptions = [];

    if (el === 2 && exceptions.includes(value) && new Date() < endDate) {
      this.openOverlay(
        Strings[this.state.lang][`banMessage`].replace("@1", value)
      );
    }

    this.setState((prevState) => {
      const valid = validate(
        value,
        prevState.form[prevState.step].fields[el].validate,
        settings
      );
      prevState.form[prevState.step].fields[el] = {
        ...prevState.form[prevState.step].fields[el],
        value,
        touched: true,
        error: valid,
      };

      const completed =
        prevState.form[prevState.step].fields.filter(
          (field) => (!field.touched || field.error) && field.type !== "results"
        ).length === 0;
      prevState.form[prevState.step].complete = completed;
      return prevState;
    });
  };

  openOverlay = (content) => {
    this.setState({
      showOverlay: true,
      overlayContent: content,
    });
  };

  closeOverlay = () => {
    this.setState({
      showOverlay: false,
      overlayContent: "",
    });
  };

  render() {
    const activeStep = this.state.form.filter((step) => step.active);

    let content = (
      <form id="branntips-form" className="md:pt-48 pt-12 md:pb-48 pb-32">
        <ActiveStep
          step={activeStep[0]}
          changeHandler={this.changeHandler}
          form={this.state.form}
          overlayHandler={this.openOverlay}
        />
      </form>
    );
    if (this.state.completed) {
      content = (
        <Finish
          step={this.state.finish}
          data={this.state.currentDep}
          sendMe={this.state.sendMe}
          click={this.sendMe}
        />
      );
    }

    let main = (
      <BounceLoader
        color="#FF4600"
        css={{
          position: "fixed",
          left: "50%",
          top: "50vh",
          WebkitTransform: "translate(-50%,-50%)",
          transform: "translate(-50%,-50%)",
        }}
      />
    );
    if (this.state.error && !this.state.loading) {
      main = (
        <div
          className="text-2xl font-bold text-red text-center"
          style={{
            position: "fixed",
            left: "50%",
            top: "50vh",
            WebkitTransform: "translate(-50%,-50%)",
            transform: "translate(-50%,-50%)",
          }}
        >
          {this.state.error}
          <br />
          <Button
            click={() => this.setState({ error: false })}
            color="red"
            name={Strings[this.state.lang].prev}
            className="mx-auto mt-4"
          />
        </div>
      );
    } else if (!this.state.loading) {
      main = (
        <React.Fragment>
          <Sidebar
            finish={this.state.finish}
            completed={this.state.completed}
            steps={this.state.form.map(({ name, active, complete }) => ({
              name,
              active,
              complete,
              changeStep: this.changeStep,
            }))}
          />
          <main className="w-full md:h-screen overflow-hidden relative">
            <div className="main-inner md:pl-24 sm:pl-12 pl-8 xxxl:pr-48 md:pr-24 sm:pr-9 pr-6 relative md:h-screen md:overflow-auto border-box relative">
              {content}
            </div>
            {this.state.moreThanTablet && !this.state.completed ? (
              <Button
                click={() =>
                  (window.location.href =
                    document.body.dataset.lang === "default" ? "/" : "/en")
                }
                color="grey"
                name={Strings[this.state.lang].cancel}
                className="absolute pin-t pin-r mt-12 xl:mr-24 mr-9"
              />
            ) : null}
            {!this.state.completed ? (
              <div className="bottom-nav md:absolute fixed pin-l pin-b w-full xxl:py-4 py-2 flex items-center md:justify-between justify-center sm:bg-white xl:px-24 px-9 sm:shadow-sm">
                {this.state.step > 0 && this.state.moreThanPhone ? (
                  <Button
                    click={() => this.changeStep(this.state.step - 1)}
                    color="grey"
                    name={Strings[this.state.lang].prev}
                    className="mr-auto"
                  />
                ) : null}
                {this.state.form.length > this.state.step ? (
                  <Button
                    click={
                      this.state.form.length - 1 === this.state.step
                        ? this.submitHandler
                        : () => this.changeStep(this.state.step + 1)
                    }
                    color="dark"
                    name={
                      this.state.form.length - 1 === this.state.step
                        ? Strings[this.state.lang].submit
                        : Strings[this.state.lang].next
                    }
                    disabled={
                      activeStep[0].skip ? false : !activeStep[0].complete
                    }
                    className="sm:ml-auto"
                  />
                ) : null}
              </div>
            ) : null}
          </main>
          <Overlay show={this.state.showOverlay} close={this.closeOverlay}>
            {this.state.overlayContent}
          </Overlay>
        </React.Fragment>
      );
    }

    return (
      <div className="BrannTips-form flex w-full md:h-screen md:flex-row flex-col font-hk">
        <div className="deco md:w-5 w-3 h-full fixed pin-l pin-t"></div>
        {!this.state.completed && this.state.step > 0 && this.state.phone ? (
          <Button
            click={() => this.changeStep(this.state.step - 1)}
            type="back"
            name={Strings[this.state.lang].prev}
            className="absolute pin-l pin-t ml-6 z-10"
          />
        ) : null}
        {!this.state.completed && this.state.phone ? (
          <Button
            click={() =>
              (window.location.href =
                document.body.dataset.lang === "default" ? "/" : "/en")
            }
            type="cancel"
            name={Strings[this.state.lang].cancel}
            className="absolute pin-r pin-t mr-6 z-10"
          />
        ) : null}
        {main}
      </div>
    );
  }
}

export default App;
